import { css } from '@/styled-system/css';

export const messageListWrapperStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  height: '100%',
});

export const messageListThreadStyles = css.raw({
  paddingInline: 'default',
  paddingTop: 'tighter',
  overflowY: 'auto',
  flex: 1,
  width: '100%',
});

export const conversationIntroTextStyles = css.raw({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center',
  marginBottom: 'tighter',
  textAlign: 'center',
});
